import React, { useEffect, useState } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import {
  getCurrentIssue,
  // currentIssueReducer,
  getCurrentIssueData,
} from '../../entity/current-issue/CurrentIssue'
import TopImages from '../../Pages/Homepage/components/TopImages'
import { useDispatch } from 'react-redux'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { getUserData } from '../../entity/user/model/selector/getUserData/getUserData'
import SiteCoverUpdateModal from '../SiteCoverUpdateModal/SiteCoverUpdateModal'
import { MdOutlineModeEdit } from 'react-icons/md'

const CurrentIssue = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const currentIssue = useSelector(getCurrentIssueData, shallowEqual)
  const user = useSelector(getUserData, shallowEqual)

  const [isOpen, setIsOpen] = useState(false)

  const modalHandler = () => {
    setIsOpen(prev => !prev)
  }

  useEffect(() => {
    dispatch(getCurrentIssue())
  }, [dispatch])

  return (
    currentIssue?.id && (
      <Row className='homepage-toprow group relative'>
        <Col md='auto' className='moambe-img'>
          <a href={currentIssue?.issue_url || '#'} target='_blank' rel='noopener noreferrer'>
            {currentIssue?.cover ? <img src={currentIssue?.cover} alt='cover' /> : null}
            <p>{t('homepage.currentIssue')}</p>
            <p>{currentIssue?.number}</p>
          </a>
          <p>ISSN - {currentIssue?.issn}</p>
        </Col>
        <Col md='auto' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <TopImages images={[currentIssue.title, currentIssue.editorial]} />
        </Col>
        {user?.role === 'admin' && (
          <MdOutlineModeEdit
            className='opacity-0 group-hover:opacity-100 my-2 text-4xl hover:scale-110 transition-all cursor-pointer text-[#326383] absolute top-0 left-0 border-2 border-[#326383] rounded-full p-1'
            onClick={modalHandler}
          />
        )}
        {isOpen && <SiteCoverUpdateModal isOpen={isOpen} onClose={modalHandler} />}
      </Row>
    )
  )
}

export default CurrentIssue
